import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--cta",
  "use": "icon-arrow--cta-usage",
  "viewBox": "0 0 7 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 12\" id=\"icon-arrow--cta\"><path d=\"M1.317.23A.73.73 0 0 0 .776 0a.783.783 0 0 0-.777.798c0 .223.092.426.242.582l4.566 4.627L.24 10.62a.847.847 0 0 0-.242.582c0 .446.346.798.777.798a.73.73 0 0 0 .541-.23l5.075-5.14A.88.88 0 0 0 6.666 6a.85.85 0 0 0-.274-.622L1.317.23Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol